import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendars } from "../../../components/Calendar/Calendar";
import { validateInputText } from "../../../utilities/ValidateUtil";
export default function P410Search2({ dataInfoA, submitted, submitForm, onChangeAction, action }) {
    const [data, setData] = useState({
        versionNo: 0,
        beginDate: dataInfoA && dataInfoA.beginDate && dataInfoA.beginDate !== "" ? new Date(dataInfoA.beginDate) : new Date(),
        endDate: dataInfoA && dataInfoA.endDate && dataInfoA.endDate !== "" ? new Date(dataInfoA.endDate) : new Date(),
        remark: "",
    });

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    useEffect(() => {

        if (action && action.action === "แก้ไข") {
            setData({
                versionNo: dataInfoA.versionNo ? dataInfoA.versionNo : 0,
                beginDate: dataInfoA && dataInfoA.beginDate && dataInfoA.beginDate !== "" ? new Date(dataInfoA.beginDate) : new Date(),
                endDate: dataInfoA && dataInfoA.endDate && dataInfoA.endDate !== "" ? new Date(dataInfoA.endDate) : new Date(),
                remark: dataInfoA.remark,
            });
        } else {
            setData({
                versionNo: 0,
                beginDate: new Date(),
                endDate: new Date(),
                remark: "",
            });
        }
    }, [dataInfoA]);

    return (
        <>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-3">
                    <label>แบบที่</label>
                    <InputText type="text" placeholder="แบบที่" value={data.versionNo} disabled />
                </div>
            </div>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-4">
                    <label>ช่วงวันที่ในการใช้แบบประเมิน จาก</label>
                    <Calendars
                        maxLength="10"
                        key="beginDate"
                        id="beginDate"
                        inputClassName={submitted && !data.beginDate ? "p-invalid" : ""}
                        value={new Date(data.beginDate)}
                        onChange={(e) => onInputTextChange(e, "beginDate")}
                    // minDate={new Date(formObject.announce_start_date)}
                    // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                    />
                    {submitted && !data.beginDate && validateInputText("beginDate", "ช่วงวันที่ในการใช้แบบประเมิน")}
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>ถึง</label>
                    <Calendars
                        maxLength="10"
                        key="endDate"
                        id="endDate"
                        inputClassName={submitted && !data.endDate ? "p-invalid" : ""}
                        value={new Date(data.endDate)}
                        onChange={(e) => onInputTextChange(e, "endDate")}
                    // minDate={new Date(formObject.announce_start_date)}
                    // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                    />
                    {submitted && !data.endDate && validateInputText("endDate", "ช่วงวันที่ในการใช้แบบประเมิน")}
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-8">
                    <label>หมายเหตุ</label>
                    <InputText type="text" placeholder="หมายเหตุ" maxLength="200" value={data.remark} onChange={(e) => onInputTextChange(e, "remark")} />
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <div style={{ display: "flex", marginBottom: "10px" }}>
                        <Button
                            className="p-button p-button-success btn-srh-responsive"
                            icon="pi pi-save"
                            // label={action.action} 
                            label={"บันทึก"}
                            style={{ width: 130 }}
                            onClick={() => submitForm(data, "lev1")} />

                        <Button
                            className="p-button-secondary p-button btn-srh-responsive"
                            icon ="pi pi-arrow-left"
                            label="กลับหน้าจอหลัก"
                            style={{ width: 130, marginLeft: "5px" }}
                            // onClick={() => {setAction({tab:1}) }}
                            onClick={() => onChangeAction(1)}
                        />
                        {action && action.action === "แก้ไข" ? <Button className="p-button-danger p-button btn-srh-responsive" icon="pi pi-trash" label="ลบรายการ" style={{ width: 130, marginLeft: "5px" }} onClick={() => submitForm(data, "ลบรายการ")} /> : ""}
                    </div>
                </div>
            </div>
        </>
    );
}
